import { useState, useEffect } from 'react';
import DontShowAgain from './DontShowAgain.js';

/**
 * Determina se il messaggio relativo a `id` è stato letto.
 *
 * Lo stato del messaggio viene riletto ad ogni cambiamento di `reloadCond`.
 */
function useDontShowAgainMessageRead(id, reloadCond) {
    const [messageRead, setMessageRead] = useState(DontShowAgain.isDontShowAgainOptionSelected(id));
    useEffect(() => {
        setMessageRead(DontShowAgain.isDontShowAgainOptionSelected(id)); // rileggo
    }, [id, reloadCond]);
    return messageRead;
}

export { useDontShowAgainMessageRead as default };
